// src/components/watch/Filters.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Filters.css';
import { SearchIcon } from 'lucide-react';

const Filters = ({ onFilter }) => {
  const [filters, setFilters] = useState({
    status: 'all',
    minPool: '',
    inputSearch: '',
    timeFrame: 'all',
    token: '',
  });

  const handleFilterChange = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };
    setFilters(newFilters);
    onFilter(newFilters);
  };

  return (
    <div className="filters-container">
      <div className="filter-group">
        <select
          className="filter-select"
          value={filters.status}
          onChange={e => handleFilterChange('status', e.target.value)}
        >
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="completed">Completed</option>
        </select>
      </div>
      {/* <div className="filter-group">
        <select
          className="filter-select"
          value={filters.timeFrame}
          onChange={e => handleFilterChange('timeFrame', e.target.value)}
        >
          <option value="all">All Time</option>
          <option value="today">Today</option>
          <option value="thisWeek">This Week</option>
        </select>
      </div>
      <div className="filter-group">
        <select
          placeholder="Token"
          className="filter-select"
          value={filters.timeFrame}
          onChange={e => handleFilterChange('token', e.target.value)}
        >
          <option value="btc">BTC</option>
          <option value="eth">ETH</option>
          <option value="xrp">XRP</option>
        </select>
      </div> */}
      <div className="flex-grow">&nbsp;</div>

      <div className="filter-group relative">
        <input
          placeholder="Search"
          className="filter-input"
          value={filters.inputSearch}
          onChange={e => handleFilterChange('inputSearch', e.target.value)}
        />
        <div className="absolute right-4 top-3.5">
          <SearchIcon size={20} />
        </div>
      </div>
    </div>
  );
};

Filters.propTypes = {
  onFilter: PropTypes.func.isRequired,
};

export default Filters;
